import * as React from 'react';
import CreateContactButton from "./CreateContactButton";

export default class ContactListEmptyView extends React.Component<{}, {}> {
	render() {
		return (
			<div className={"c-empty-view"}>
				<div className={"description"}>You don't have any contacts yet.</div>
				<CreateContactButton/>
			</div>
		);
	}
}
